<!-- 
Listing of scheduled jobs.
-->
<template>
  <div>
    <v-card class="home">
      <our-simple-table-header
        :total-items="listing.paging.totalItems"
        @click:refresh="refresh"
      />
      <our-table-busy-indicator :show="listing.loading"/>
      <v-data-table 
        ref="scheduledJobTable" 
        :headers="headers" 
        :items="listing.data" 
        :pagination="listing.paging" 
        :total-items="listing.paging.totalItems" 
        :no-data-text="noDataText"
        must-sort 
        hide-actions
        @click:refresh="refresh" 
        @update:pagination="updatePagination"
      >
        <template slot="items" slot-scope="props">
          <tr @click.stop="open(props.item.id)">
            <our-nav-col :row="props.item.type"/>
            <td>{{ lookups.jobTypeDescriptions[props.item.type] }}</td>
            <td>
              <span :class="props.item.isOverdue ? 'orange--text': ''">{{ props.item.due | compactDateTime }}</span>
              {{ props.item | recurrence | bracketed }}
            </td>
            <td>{{ props.item.lastRun | compactDateTime }}</td>
            <td>
              <span :class="props.item.status | statusColour">
                {{ lookups.scheduledJobStatusDescriptions[props.item.status] }} 
              </span>
              {{ props.item.lastRunTimeTaken | timespan | bracketed }}
              <v-tooltip v-if="props.item.lastRunDescription" bottom>
                <v-icon slot="activator" small>sms</v-icon>
                <our-multiline-text :text="props.item.lastRunDescription" />
              </v-tooltip>
            </td>
            <td>
              <span v-if="props.item.isSuspended" class="orange--text">Suspended. </span>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import tableMixins from "@/mixins/table.mixins";
import filterMixins from "@/mixins/filter.mixins";
import lookupMixins from "@/mixins/lookup.mixins";
import * as action from "@/store/scheduled-jobs/action-types";
import * as mutation from "@/store/scheduled-jobs/mutation-types";

export default {
  filters: {
    recurrence(job) {
      if (job.frequency > 1) {
        return `repeating every ${job.frequency} ${job.frequencyUnit.toLowerCase()}s`;
      } else {
        return `repeating every ${job.frequencyUnit.toLowerCase()}`;
      }
    },
    statusColour(status) {
      return status == "Failed" ? "red--text font-weight-bold" : "";
    }
  },
  mixins: [tableMixins, filterMixins, lookupMixins],
  data() {
    return {
      action: action.LIST,
      pagingMutation: mutation.LIST_SET_PAGING
    };
  },
  computed: {
    headers() {
      return [
        { text: "", value: "Id", class: "navCol", width: 0, sortable: false },
        { text: "Type", value: "Type", sortable: true },
        { text: "Due", value: "Due", sortable: true },
        { text: "Last run", value: "LastRun", sortable: true },
        { text: "Outcome (time taken)", value: "Status", sortable: true },
        { text: "Other info", sortable: false }
      ];
    },
    listing() {
      return this.$store.state.scheduledJobs.listing;
    },
    loaded() {
      return this.listing.loaded;
    }
  },
  watch: {
    loaded() {
      this.reload();
    }
  },
  mounted() {
    this.reload();
  },
  methods: {
    reload() {
      if (!this.listing.loading) {
        this.populate();
      }
    },
    open(id) {
      this.$router.push(`/scheduled-jobs/${id}`);
    }
  }
};
</script>
